import React from 'react';
import Icon from '@/components/atoms/Icon';

import './Close.scss';

const Close = (props) => (
    <Icon iconName="Close" {...props}>
        <svg viewBox="0 0 11.31 11.31" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <path
                stroke={0}
                fillRule="evenodd"
                d="M9.9 0l1.42 1.42-4.25 4.24 4.25 4.24-1.42 1.42-4.24-4.25-4.24 4.25L0 9.9l4.25-4.24L0 1.42 1.42 0l4.24 4.25z"
            />
        </svg>
    </Icon>
);

export default Close;
